import { AvatarOptions } from "./UserAvatar.types";
import { USER_GENDERS } from "@shared/Types/UserRoleBadgeEnum";
import { avatarFallbackColorSelector } from "@shared/Avatar/AvatarFallbackColorSelector";
import React from "react";
import styled from "@emotion/styled";
import { Avatar, SxProps } from "@mui/material";
import { AvatarMaleFallbackIcon } from "@icons/AvatarMaleFallbackIcon";
import { AvatarFemaleFallbackIcon } from "@icons/AvatarFemaleFallbackIcon";
import { AvatarFallbackIcon } from "@icons/AvatarFallbackIcon";

export function UserAvatarFactory({
    uuid,
    avatar,
    onClick,
    onError,
    component: AvatarComponent = DefaultAvatar,
    gender,
    fallbackColor,
    fallbackIcon,
    sx,
}: AvatarOptions) {
    return (
        <AvatarComponent
            src={avatar}
            onClick={onClick}
            onError={onError}
            sx={{
                backgroundColor: "var(--community-color-snow-white)",
                ...sx,
            }}
        >
            {fallbackIcon ? (
                <>{fallbackIcon}</>
            ) : (
                prepareAvatarContent(
                    fallbackColor ?? avatarFallbackColorSelector(uuid),
                    gender,
                )
            )}
        </AvatarComponent>
    );
}

const DefaultAvatar = styled(Avatar)({});

export function getAvatarFallbackIcon(sx: SxProps, gender?: string) {
    switch (true) {
        case gender === USER_GENDERS.MALE:
            return <AvatarMaleFallbackIcon {...sx} />;
        case gender === USER_GENDERS.FEMALE:
            return <AvatarFemaleFallbackIcon {...sx} />;
        default:
            return <AvatarFallbackIcon {...sx} />;
    }
}

export function prepareAvatarContent(color: string, gender?: string) {
    return getAvatarFallbackIcon(
        {
            color: color,
            width: "100%",
            height: "100%",
        },
        gender,
    );
}
